import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/LayoutContainerAdapter';
import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { layoutSaved, layoutSaveFailed, saveLayout, SaveLayoutActionType } from '../../actions/layout/saveLayout';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';
import layoutFormDataToDtos from './layoutFormDataToDtos';

function* saveLayoutSaga({ payload }: SaveLayoutActionType) {
  const { placeUuid, layoutUuid, layoutFormData } = payload;
  const token = yield getAuthenticationToken();
  const { layoutDto, tableDtos, tableTypeDtos } = layoutFormDataToDtos(placeUuid, layoutUuid, layoutFormData);
  const timestamp = moment();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateLayout, token, {
    placeUuid,
    layoutDto,
    tableDtos,
    tableTypeDtos,
  });
  if (!response.error) {
    const { layoutContainerDto, affectedReservationDtos } = response;
    const affectedReservations = affectedReservationDtos.map(reservationFromDto);
    yield put(layoutSaved({ placeUuid, layoutUuid, ...fromDto(layoutContainerDto), timestamp, affectedReservations }));
  } else {
    yield put(layoutSaveFailed({ placeUuid, layoutUuid, timestamp }));
  }
}

export default function* watchSaveLayout() {
  yield takeEvery(saveLayout, saveLayoutSaga);
}
